const state = {
  navIndex: Number(sessionStorage.navIndex),
  userRole: 1
}
export default state
